import dynamic from 'next/dynamic';

// Each logo is loaded on demand so a page only downloads the logos it renders

export const FooterGolf = dynamic(
  () => import('@/assets/logos/bravo/footer/footer-golf.svg'),
);
export const FooterRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/footer/footer-rejseklubben.svg'),
);
export const FooterSafari = dynamic(
  () => import('@/assets/logos/bravo/footer/footer-safari.svg'),
);
export const LogoGolf = dynamic(
  () => import('@/assets/logos/bravo/logo/logo-golf.svg'),
);
export const LogoRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/logo/logo-rejseklubben.svg'),
);
export const LogoSafari = dynamic(
  () => import('@/assets/logos/bravo/logo/logo-safari.svg'),
);
export const NavigationGolf = dynamic(
  () => import('@/assets/logos/bravo/navigation/navigation-golf.svg'),
);
export const NavigationRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/navigation/navigation-rejseklubben.svg'),
);
export const NavigationSafari = dynamic(
  () => import('@/assets/logos/bravo/navigation/navigation-safari.svg'),
);
export const NoResultsGolf = dynamic(
  () => import('@/assets/logos/bravo/noResults/noResults-golf.svg'),
);
export const NoResultsRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/noResults/noResults-rejseklubben.svg'),
);
export const NoResultsSafari = dynamic(
  () => import('@/assets/logos/bravo/noResults/noResults-safari.svg'),
);
export const PositiveGolf = dynamic(
  () => import('@/assets/logos/bravo/positive/positive-golf.svg'),
);
export const PositiveRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/positive/positive-rejseklubben.svg'),
);
export const PositiveSafari = dynamic(
  () => import('@/assets/logos/bravo/positive/positive-safari.svg'),
);
export const NoFavoritesGolf = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-golf.svg'),
);
export const SymbolGolf = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-golf.svg'),
);
export const NoFavoritesRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-rejseklubben.svg'),
);
export const SymbolRejseklubben = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-rejseklubben.svg'),
);
export const NoFavoritesSafari = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-safari.svg'),
);
export const SymbolSafari = dynamic(
  () => import('@/assets/logos/bravo/symbol/symbol-safari.svg'),
);
export const Dankort = dynamic(() => import('@/assets/logos/dankort.svg'));
export const Footer = dynamic(() => import('@/assets/logos/footer.svg'));
export const Login = dynamic(() => import('@/assets/logos/login.svg'));
export const Logo = dynamic(() => import('@/assets/logos/logo.svg'));
export const Mastercard = dynamic(
  () => import('@/assets/logos/mastercard.svg'),
);
export const MobilePay = dynamic(() => import('@/assets/logos/mobilepay.svg'));
export const Navigation = dynamic(
  () => import('@/assets/logos/navigation.svg'),
);
export const Negative = dynamic(() => import('@/assets/logos/negative.svg'));
export const NoFavorites = dynamic(
  () => import('@/assets/logos/noFavorites.svg'),
);
export const NoResults = dynamic(() => import('@/assets/logos/noResults.svg'));
export const Positive = dynamic(() => import('@/assets/logos/positive.svg'));
export const RejsegarantiFonden = dynamic(
  () => import('@/assets/logos/rejsegaranti-fonden.svg'),
);
export const Travelheartfamily = dynamic(
  () => import('@/assets/logos/travelheartfamily.svg'),
);
export const Trustpilot = dynamic(
  () => import('@/assets/logos/trustpilot.svg'),
);
export const Visa = dynamic(() => import('@/assets/logos/visa.svg'));

// Declared under another name so it doesn't shadow the global Symbol in this module
const SymbolLogo = dynamic(() => import('@/assets/logos/symbol.svg'));

export { SymbolLogo as Symbol };
